import React, { useMemo } from 'react';
import { string, shape, array } from 'prop-types';

// import { useStyle } from '../../lib/util/classify.js';
import { useStyle } from '../../lib/util/classify';
import GalleryItem from './item';
import defaultClasses from './gallery.module.css';

//import { useUserContext } from '../../peregrine/lib/context/user';
//import { useHistory } from 'react-router-dom';

// map Magento 2.3.1 schema changes to Venia 2.0.0 proptype shape to maintain backwards compatibility
const mapGalleryItem = item => {
    const { small_image } = item;
    return {
        ...item,
        small_image:
            typeof small_image === 'object' ? small_image.url : small_image
    };
};

/**
 * Renders a Gallery of items. If items is an array of nulls Gallery will render
 * a placeholder item for each.
 *
 * @params {Array} props.items an array of items to render
 */
const Gallery = props => {
    const { items, skeleton, showAddToCart = false } = props;

    //    const [{ isSignedIn: isUserSignedIn }] = useUserContext();
    //
    //    if (!PUBLIC_PRODUCTS && !isUserSignedIn && !skeleton) {
    //        console.log('Login required from Gallery');
    //        const history = useHistory();
    //        const { push } = history;
    //        push('/customer/account/login?r=' + window.location.pathname);
    //        return null;
    //    }

    const classes = useStyle(defaultClasses, props.classes);

    const galleryItems = useMemo(
        () =>
            items.map(item => {
                if (item === null) {
                    return <GalleryItem item={item} />;
                }
                return (
                    <GalleryItem
                        key={item.id}
                        item={mapGalleryItem(item)}
                        showAddToCart={showAddToCart}
                    />
                );
            }),
        [items]
    );

    return (
        <div className={classes.root}>
            <div className={classes.items}>{galleryItems}</div>
        </div>
    );
};

Gallery.propTypes = {
    classes: shape({
        filters: string,
        items: string,
        pagination: string,
        root: string
    }),
    items: array.isRequired
};

export default Gallery;
